<template>
    <el-dialog v-if="dialogVisible" :title="$t('billingPage.position')" :visible.sync="dialogVisible" width="750px" :before-close="handleCancel">
      <el-form :model="form" :inline="true">
        <el-checkbox-group v-model="checkList" class="flex-align flex-wrap">
            <div v-for="(item,index) in positionList" :key="index" style="width:49%;margin: 0 0 10px 0">
                <el-checkbox :label="item.label"></el-checkbox>
                <BjInputNumber v-model="item.percentage" :placeholder="$t('inputText')" clearable style="width:120px;margin-left:10px"/>
            </div>
        </el-checkbox-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleSend">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </template>
  <script>
  export default {
    props: {
        positionList: {
            type: Array,
            default: [],
        },
        checkList: {
            type: Array,
            default: [],
        },
    },
    data() {
      return {
        dialogVisible: false,
        form: {},
        dataList: [],
      };
    },
    mounted() {
    },
    methods: {
        onDelete(index){
            this.dataList.splice(index,1)
        },
        handleCancel() {
            this.dialogVisible = false;
        },
        handleSend() {
            let arr = []
            this.checkList.forEach(item=>{
                this.positionList.forEach(jitem=>{
                    if(item == jitem.label){
                        arr.push({name: jitem.label, percentage: jitem.percentage})
                    }
                })
            })
            const total = arr.reduce((pre, cur) => (pre += Number(cur.percentage)), 0);
            if(total != 100) return this.$message.warning(this.$t('billingPage.blTip'))
            this.handleCancel();
            this.$emit('submit', arr);
        },
    },
  };
  </script>
  